import { useFeatureGates } from '@office-start/feature-gates-service';
import { useMemo } from 'react';
import { getActionsGates } from './../util/systemActionHelper';
/**
 * Get all feature gates, settings for overall actions and specific actions.
 *
 * @returns ContentActionsFeatureGates if featureGates, Undefined otherwise
 */
export var useContentActionsGatesEnabled = function () {
    var featureGates = useFeatureGates().data;
    return useMemo(function () {
        // Wait for hook to resolve.
        if (!featureGates) {
            return undefined;
        }
        return getActionsGates(featureGates.result);
    }, [featureGates]);
};
//# sourceMappingURL=useContentActionsEnabled.js.map